import { render, staticRenderFns } from "./fccCodeEditor.vue?vue&type=template&id=207b5bc7"
import script from "./fccCodeEditor.vue?vue&type=script&lang=js"
export * from "./fccCodeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports